import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import is from 'is_js';
import PropTypes from 'prop-types';

import { connect, log, ApiResponseHelper } from 'omni-common-ui';
import { actions as progressTestActions } from 'data/ProgressTests';
import { actions as progressReportsActions } from 'data/ProgressReports';
import {
  actions as progressTestsPlanActions,
  isMarkable,
  getDefaultProgressTestIndex,
} from 'data/ProgressTestsPlan';

export class MidtermAndFinalExam extends Component {
  // triggered on first load
  componentWillMount() {
    this._loadIfNeed(this.props);
    this._fetchProgressTestModels(this.props);
    this._redirectToCourseView(this.props);
    this._checkIsMarkableInMarkMode(this.props);
    this._checkIsCanBeOverwriteInMarkMode(this.props);
  }

  // triggered on PT navigation
  componentWillReceiveProps(nextProps) {
    this._loadIfNeed(nextProps);
    this._fetchProgressTestModels(nextProps);
    this._redirectToCourseView(nextProps);
    this._checkIsMarkableInMarkMode(nextProps);
    this._checkIsCanBeOverwriteInMarkMode(nextProps);
  }

  _loadIfNeed(props) {
    const { groupId } = props.params;
    props.fetchProgressTestPlanIfNeeded(groupId);
  }

  _redirectToCourseView(props) {
    const { groupId, currentProgressTestIndex, buildRoute, replace } = props;
    if (! (currentProgressTestIndex >= 0)) return;
    if (props.location.pathname.endsWith('exam')) {
      replace(buildRoute(
        `/group/${groupId}` +
        `/exam/${currentProgressTestIndex}/course`
      ));
    }
  }

  _fetchProgressTestModels(props = this.props) {
    const {
      progressTest,
      progressReports,
      currentProgressTestPlan,
    } = props;
    if (! currentProgressTestPlan) return;
    const { groupId } = props.params;
    if (ApiResponseHelper.shouldFetch(progressTest)) {
      props.fetchProgressTest(groupId, currentProgressTestPlan);
    }
    if (ApiResponseHelper.shouldFetch(progressReports)) {
      props.fetchProgressReport(groupId);
    }
  }

  _checkIsMarkableInMarkMode(props) {
    const { markable, params, buildRoute, replace } = props;

    if (is.boolean(markable) && ! markable && params.mode === 'edit') {
      log.warn('MidtermAndFinalExam: not a markable test; leaving edit mode');
      return replace(buildRoute({ mode: '' }));
    }
  }

  _checkIsCanBeOverwriteInMarkMode(props) {
    const { progressTest, params, buildRoute, replace } = props;
    const { studentId } = params;
    if (! ApiResponseHelper.hasSucceeded(progressTest) || ! studentId) return;
    const { canBeOverwrite } = progressTest.data.studentProgressTestResults.get(studentId);

    if (is.boolean(canBeOverwrite) && ! canBeOverwrite && params.mode === 'edit') {
      log.warn('MidtermAndFinalExam: not an overwritable skill; leaving edit mode');
      return replace(buildRoute({ mode: '' }));
    }
  }

  render() {
    const { progressTestPlan, progressTest } = this.props;
    if (! progressTestPlan || ! progressTest) return null;
    return <div className={styles.MidtermAndFinalExam}>
      <div className={styles.MidtermAndFinalExam_content}>
        {this.props.children}
      </div>
    </div>;
  }
}

MidtermAndFinalExam.getCurrentRouteSegment = (props) =>
  props.routes[props.routes.length - 1];

MidtermAndFinalExam.propTypes = {
  children: PropTypes.node,
  progressTest: PropTypes.object,
  progressReports: PropTypes.object,
  progressTestPlan: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  pushRoute: PropTypes.func.isRequired,
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  buildRoute: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  markable: PropTypes.bool.isRequired,
};


export function mapStateToProps(state, ownProps) {
  const { groupId, progressTestIndex } = ownProps.params;
  const group = state.get('rootReducer').get('groups').get(groupId);
  const progressTestPlan =
    state.get('rootReducer').get('progressTestsPlan').get(groupId); // string groupId
  const midtermAndFinalExams = progressTestPlan &&
    progressTestPlan.data &&
    progressTestPlan.data.filter((ptp) => ptp.isUnitQuiz === false);
  if (! progressTestPlan || ! midtermAndFinalExams) {
    return;
  }
  const defaultProgressTestIndex = getDefaultProgressTestIndex(state, groupId, false);
  const currentProgressTestIndex = progressTestIndex || defaultProgressTestIndex;
  const currentProgressTestPlan = midtermAndFinalExams.toList()
    .sortBy((progressTest) => progressTest.index).get(currentProgressTestIndex);
  const currentProgressTestId = currentProgressTestPlan.id;
  const progressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);

  return {
    groupId,
    progressTestPlan,
    currentProgressTestPlan,
    progressTest,
    currentProgressTestIndex,
    progressReports: group && group.data.progressReports,
    markable: isMarkable(state, groupId, currentProgressTestIndex, false),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(progressTestActions, dispatch),
    bindActionCreators(progressReportsActions, dispatch),
    bindActionCreators(progressTestsPlanActions, dispatch),
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MidtermAndFinalExam);



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExam/component.jsx